const isValidV4UUID = (uuid) => {
  return /^[A-F\d]{8}-[A-F\d]{4}-4[A-F\d]{3}-[89AB][A-F\d]{3}-[A-F\d]{12}$/i.test(uuid)
}

module.exports = {
  isValidV4UUID
}



// WEBPACK FOOTER //
// ./src/helpers/UUID.js